import React from 'react'

import Icon from 'Pods/Shared/Icon/Icon'

function EmptyInbox() {
  return (
    <div className="popover-content is-empty">
      <p className="u-text-center">
        <Icon type={['far', 'envelope']} color="grey" size="5x" />
        You have no messages yet.
        <br />
        Go to <a href="/profile/inbox" className="link--primary-dark">My Conversations</a>
      </p>
    </div>
  )
}

export default EmptyInbox
